import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {change, getFormValues} from 'redux-form';
import {Forms} from '../../../../models/forms';
import {AcceptorsFilterForm} from '../../model';
import {getAcceptorsFilterName} from '../../pipes';
import View from './view';
import {Props} from './model';

export const AcceptorsFilterList: React.FC<Props> = (props) => {
  const filterFormValues = useSelector(getFormValues(Forms.acceptorsFilterForm)) as AcceptorsFilterForm;
  const prevFilterFormValues = React.useRef<boolean[]>(filterFormValues?.category ?? []);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!filterFormValues?.category) {
      dispatch(change(Forms.acceptorsFilterForm, getAcceptorsFilterName(String(0), 'category'), true));
      prevFilterFormValues.current = [true];
    } else {
      const isAnySelected = filterFormValues.category.some((item, index) => (index ? item : false));
      if (!prevFilterFormValues.current[0] && filterFormValues.category[0]) {
        if (isAnySelected) dispatch(change(Forms.acceptorsFilterForm, 'category', [true]));
      } else {
        if (isAnySelected) {
          if (filterFormValues.category[0])
            dispatch(change(Forms.acceptorsFilterForm, getAcceptorsFilterName(String(0), 'category'), false));
        } else {
          if (!filterFormValues.category[0])
            dispatch(change(Forms.acceptorsFilterForm, getAcceptorsFilterName(String(0), 'category'), true));
        }
      }
      prevFilterFormValues.current = filterFormValues.category;
    }
  }, [filterFormValues]);

  return <View {...props} />;
};
